<script lang="ts">
    import { Col } from "sveltestrap";
    import { Cssone, Csstwo, CustomizedTree, Dashboard, indexfile, Js, Jsone, Jstwo, Scsstwo, SubFile, Typography } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
	import { TreeView, TreeBranch, TreeLeaf } from "svelte-tree-view-component";
</script>
<Col sm="6">
    <Card headerTitle={CustomizedTree} cardHeaderprops="pb-0">
      <div slot="contentbody" class="customized-tree-flow">
        <TreeView  lineColor="#ff0000" iconBackgroundColor="#ff0000" iconColor="#000000" branchHoverColor="#ff0000">
            <TreeBranch rootContent="Admin">
                <TreeBranch rootContent="Assets">
                    <TreeBranch defaultClosed rootContent="Css">
                        <TreeLeaf>{Cssone}</TreeLeaf>
                        <TreeLeaf>{Csstwo}</TreeLeaf>
                    </TreeBranch>
                    <TreeBranch >
                        <div class="customized-tree" slot="root">{Js}</div>
                        <svelte:fragment slot="children">
                            <TreeLeaf>{Jsone}</TreeLeaf>
                            <TreeLeaf>{Jstwo}</TreeLeaf>
                        </svelte:fragment>
                    </TreeBranch>
                    <TreeBranch rootContent="Scss">
                        <TreeBranch defaultClosed rootContent="Sub Child">
                            <TreeLeaf>{SubFile}</TreeLeaf>
                            <TreeLeaf>{SubFile}</TreeLeaf>
                        </TreeBranch>
                        <TreeLeaf>{Scsstwo}</TreeLeaf>
                    </TreeBranch>
                </TreeBranch>
                <TreeBranch rootContent="Default">
                    <TreeLeaf>{Dashboard}</TreeLeaf>
                    <TreeLeaf>{Typography}</TreeLeaf>
                </TreeBranch>
            </TreeBranch>
            <TreeLeaf>{indexfile}</TreeLeaf>
        </TreeView>
      </div>
    </Card>
</Col>